import { useContext } from "react";
import NavigationContext from "./navigation.context";

const useEolasNavigation = () => {
  return useContext(NavigationContext);
};

export default useEolasNavigation;
